import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Link, Outlet, useLocation } from "react-router-dom";

const settingsNavigation = [
  { 
    name: "Change Password", 
    href: "/settings/change-password",
    description: "Update your password"
  }
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function SettingsPage() {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  return (
    <div className="p-4 max-w-5xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="text-sm text-gray-500 mt-1">Manage your account settings and preferences.</p>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* Settings Navigation */}
        <div className="p-4 rounded-lg border border-gray-100 bg-white shadow-sm">
          <h2 className="text-sm font-medium text-gray-900 mb-4">Settings Options</h2>
          <div className="space-y-3">
            {settingsNavigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={classNames(
                  location.pathname === item.href
                    ? "bg-customIndigo text-white"
                    : "bg-gray-50 text-gray-700 hover:bg-gray-100",
                  "block p-3 rounded-md transition"
                )}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-sm font-medium">{item.name}</span>
                    <p className="text-xs text-gray-500 mt-0.5">{item.description}</p>
                  </div>
                  <span className="text-xs">→</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
